import { Link } from "react-router-dom";
import { movieCategories } from "@/mocks/movies";

export default function CategorySection() {
  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-8 md:py-12">
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 md:gap-4">
        {movieCategories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="group relative h-28 md:h-36 rounded-xl overflow-hidden cursor-pointer bg-background-200"
          >
            <div className="absolute inset-0 bg-gradient-to-br from-primary-500/90 via-primary-600/80 to-primary-800/90 group-hover:from-primary-400/90 group-hover:via-primary-500/80 group-hover:to-primary-700/90 transition-colors duration-300"></div>
            <div className="absolute inset-0 flex flex-col items-center justify-center gap-2">
              <span className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center">
                <i className={`${cat.icon} text-background-50 text-2xl md:text-3xl`}></i>
              </span>
              <span className="text-background-50 font-semibold text-sm md:text-base whitespace-nowrap">
                {cat.name}
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}